
import register from 'ShopUiBundle/modules/app/registry';
import './basic-keyfeatures.scss';

// tslint:disable-next-line
register('basic-keyfeatures', () => import(/* webpackMode: "lazy" */'./basic-keyfeatures'));
